<template>
  <div class="d-flex flex-column justify-content-center align-items-center">
    <div :style="btnStyle" class="d-flex flex-column justify-content-center align-items-center loading-content content-circle">
      <ui-progress-circular
        :style="btnStyle"
        :stroke="3"
        :size="sizeCircle"
        color="primary"
      />
      <div class="textSplash mt-2" :style="btnStyle" v-text="text"></div>
    </div>
  </div>
</template>

<script>
//Keen UI
import UiProgressCircular from "keen-ui/src/UiProgressCircular";

export default {
  props: {
    text: { type: String, default: "Obteniendo datos" },
    textSize: { type: Number, default: 15 },
    sizeCircle: { type: Number, default : 70 },
    color: { type: String, default : '#0d6efd' }
  },

  components: {
    UiProgressCircular,
  },

  computed: {
    btnStyle() {
      return {
        "--color": this.color,
        "--text-size": this.textSize+'px',
      };
    },
  },

};
</script>

<style scoped>

  .textSplash {
    font-size: var(--text-size);
    color: var(--color);
  }

  .content-circle{
    border: 1.5px solid var(--color); 
    padding: 15px 15px; 
    border-radius: 10px;
  }

</style>
